const residenceFormConfig = {
    OwnFreeAndClear: [],
    OwnMobileHome: [
        {
            inputName: 'monthlypayments',
            transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
    ],
    Other: [
        {
            inputName: 'monthlypayments',
            transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
        {
            inputName: 'additionalInfos',
            transKey: 'FINANCING.RESIDENCE_INFOS.ADDITIONAL_INFOS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.ADDITIONAL_INFOS',
            inputType: 'text',
            isRequired: false,
            classNames: 'full',
        },
    ],
    OwnWithMortage: [
        {
            inputName: 'monthlypayments',
            transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
        {
            inputName: 'mortgageAmount',
            transKey: 'FINANCING.RESIDENCE_INFOS.MORTGAGE_AMOUNT',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MORTGAGE_AMOUNT',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
        {
            inputName: 'mortgageValue',
            transKey: 'FINANCING.RESIDENCE_INFOS.MORTGAGE_VALUE',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MORTGAGE_VALUE',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
        {
            inputName: 'mortgageHolder',
            transKey: 'FINANCING.RESIDENCE_INFOS.MORTGAGE_HOLDER',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MORTGAGE_HOLDER',
            inputType: 'text',
            isRequired: true,
            classNames: 'full',
        },
    ],
    Parents: [
        {
            inputName: 'monthlypayments',
            transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
    ],
    Rent: [
        {
            inputName: 'monthlypayments',
            transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
        {
            inputName: 'landlord',
            transKey: 'FINANCING.RESIDENCE_INFOS.LANDLORD',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.LANDLORD',
            inputType: 'text',
            isRequired: true,
            classNames: 'full',
        },
    ],
    ReserveHousing: [
        {
            inputName: 'monthlypayments',
            transKey: 'FINANCING.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            errorTransKey: 'COMMONS_FORMS.ERRORS.RESIDENCE_INFOS.MONTHLY_PAYMENTS',
            inputType: 'number',
            isRequired: true,
            classNames: 'half',
        },
    ],
};

export default residenceFormConfig;
